(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".c-faq__item").forEach((item) => {
    item.classList.add("is-hidden");
  });
});

  
  document.querySelectorAll(".c-faq__item").forEach((item) => {
    
  const faqButton = item.querySelector(".c-faq__button");
  if (faqButton) {
    faqButton.addEventListener("click", () => {
      item.classList.toggle("is-hidden");
    });
  }
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-usps"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".c-usp-slider__item");
  let index = 0;

  function showNextItem() {
    items[index].classList.remove("active");
    index = (index + 1) % items.length;
    items[index].classList.add("active");
  }

  if (window.innerWidth < 1024) {
    items[0].classList.add("active"); // Eerste item zichtbaar maken

    setInterval(showNextItem, 3000); // Elke 3 seconden wisselen
  }
});

    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mxpro-sale-hub"] && !Shopify.designMode) return;
  try {
    
let mxproSaleLastQuery=null;
function mxproSaleSyncFilters(force){
  const current=window.location.search;if(!force&&current===mxproSaleLastQuery)return;mxproSaleLastQuery=current;
  const params=new URLSearchParams(window.location.search);
  document.querySelectorAll('.mxpro-sale__quick').forEach(function(form){
    const types=params.getAll('pf_pt_product_type');
    const typeSelect=form.querySelector('[name="pf_pt_product_type"]');
    const brandSelect=form.querySelector('[name="pf_v_merk"]');
    if(types.length>1){
      if(!typeSelect.querySelector('[value="__category__"]')){const option=document.createElement('option');option.value='__category__';option.textContent='Geselecteerde categorie';typeSelect.appendChild(option);}
      typeSelect.value='__category__';
    }else{typeSelect.value=types[0]||'';}
    const brands=params.getAll('pf_v_merk');
    if(brands.length>1){if(!brandSelect.querySelector('[value="__category__"]')){const option=document.createElement('option');option.value='__category__';option.textContent='Geselecteerde merken';brandSelect.appendChild(option);}brandSelect.value='__category__';}else{brandSelect.value=brands[0]||'';}
  });
}
function mxproSaleInitFilters(){
  mxproSaleSyncFilters();
  const target=document.querySelector('.boost-sd__filter-product-list');
  if(target){let scheduled=false;new MutationObserver(function(){if(scheduled)return;scheduled=true;requestAnimationFrame(function(){scheduled=false;mxproSaleSyncFilters();});}).observe(target,{childList:true,subtree:true});}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',mxproSaleInitFilters);}else{mxproSaleInitFilters();}
window.addEventListener('popstate',mxproSaleSyncFilters);
document.addEventListener('shopify:section:load',mxproSaleSyncFilters);
document.addEventListener('submit',function(event){
  const form=event.target;if(!form.matches('.mxpro-sale__quick'))return;
  const params=new URLSearchParams(window.location.search);
  const preserveCategory=form.querySelector('[name="pf_pt_product_type"]').value==='__category__';
  const preserveBrand=form.querySelector('[name="pf_v_merk"]').value==='__category__';
  form.querySelectorAll('[data-sale-kept-filter]').forEach(function(input){input.remove();});
  params.forEach(function(value,key){
    const keep=key==='pf_pt_product_type'?preserveCategory:key==='pf_v_merk'?preserveBrand: (/^pf_/.test(key)||['q','sort','sort_by'].includes(key));
    if(keep){const input=document.createElement('input');input.type='hidden';input.name=key;input.value=value;input.setAttribute('data-sale-kept-filter','');form.appendChild(input);}
  });
  form.querySelectorAll('select').forEach(function(select){select.disabled=!select.value||select.value==='__category__';});
});

  } catch(e) { console.error(e); }
})();
})();
